document.addEventListener('DOMContentLoaded', () => {
  const featuredGiftCards = document.querySelectorAll('[data-featured-gift-card-handle]');

  featuredGiftCards.forEach((featuredGiftCard) => {
    const handle = featuredGiftCard.getAttribute('data-featured-gift-card-handle');
    const product = document.querySelector(`[data-product-handle="${handle}"]`);

    if (product) {
      featuredGiftCard.remove();
      const featuredGiftCardsGrid = document.querySelector('.featured-gift-cards__grid');
      featuredGiftCardsGrid?.classList.add('featured-gift-cards__grid--three-columns');
    }
  });
});
